import { isDiscountItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
export const getPriceRestrictionFromItemPrice = (itemPrice) => {
    if (isDiscountItemPrice(itemPrice))
        return { discountId: itemPrice.discountId };
    if (isMemberRewardItemPrice(itemPrice))
        return { rewardId: itemPrice.rewardId };
};
